import { ApiResult, PaginatedResponse, successResult } from '@synergy/api';

import { createSearchByObject } from './create-search-by-object';

export const fetchAllFromPaginated = async <T>(
    apiCall: (params: URLSearchParams) => Promise<ApiResult<PaginatedResponse<T>>>
): Promise<ApiResult<T[]>> => {
    let result: T[] = [];
    let response: ApiResult<PaginatedResponse<T>>;
    let page = 0;

    do {
        page++;
        const search = createSearchByObject({ limit: 10000, page });
        response = await apiCall(search);
        if (response.success) {
            result = result.concat(response.result.items);
        }
    } while (response.success === true && result.length < response.result.total);

    if (!response.success) {
        return response;
    }
    return successResult(result);
};
